import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import WalletViewFilter from 'components/Billing/WalletViewFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import { buildActionsButton } from 'components/Billing/actionsButton';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo, useState } from 'react';
import { BILLING_QUERIES, WALLET_VIEWS, buildCards } from 'utils/billing';

// A carteira inteira, sem degrau da esteira. O operador alterna entre os
// titulos em aberto (vencidos e a vencer, o padrao) e os baixados; cada visao
// reconsulta o endpoint com a sua query.
export default function BillingCarteira() {
  const { user, setModal } = useContext(CoreContext);
  const [walletView, setWalletView] = useState(WALLET_VIEWS.open);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({
    query:
      walletView === WALLET_VIEWS.settled
        ? BILLING_QUERIES.walletSettled
        : BILLING_QUERIES.walletOpen,
    onlyOverdue: false,
    walletView,
  });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'saldo',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
            ...buildHistoryOverride({ setModal, reload }),
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
    overdueOnly: false,
  });

  const buttons = useMemo(
    () => [buildActionsButton({ setModal, reload, user })],
    [setModal, reload, user]
  );

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Carteira"
        search
        buttons={buttons}
        filters={
          <>
            <WalletViewFilter value={walletView} onChange={setWalletView} />
            <DelayRangeFilter
              from={delayFrom}
              to={delayTo}
              onChangeFrom={setDelayFrom}
              onChangeTo={setDelayTo}
              onClear={clearDelay}
            />
          </>
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
